import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { removeFormatNumber } from '@/utils/number'
import { formatPrice } from '@/utils/index'

export const nonTradeGLTransactionAjaxMixin = {
  data() {
    return {
      actionName: '',
      glAppIntInt: ''
    }
  },
  methods: {
    async nonTradeGLTransList() {
      this.loading = true
      const apiUrl = this.$store.state.nonTrade.menu.nonTradeGLTransList
      if (apiUrl) {
        try {
          const expand = {
            branch: this.nonTradeData.branch,
            accountNo: this.nonTradeData.accountNo,
            transactionType: this.nonTradeData.type,
            documentNo: this.nonTradeData.documentNo,
            fund: this.nonTradeData.fund,
            accountNoSuffix: this.nonTradeData.suffix,
            gstAmtAE: this.nonTradeData.gstAmountAE,
            gstAmt: this.nonTradeData.gstAmount
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data.data.glTranList.length > 0) {
            data.data.glTranList.map(glDetail => {
              const glDetailList = {
                glInterface: glDetail.glInterface,
                glAccountNo: glDetail.glAcctNo,
                description: glDetail.glDesc,
                curr: glDetail.currency,
                amount: formatPrice(glDetail.amount),
                localAmount: formatPrice(glDetail.localAmount),
                gstStatus: glDetail.gstStatus,
                gstRate: formatPrice(glDetail.gstRate),
                gstAmount: formatPrice(glDetail.gstAmount),
                branch: glDetail.branch,
                fund: glDetail.fund,
                deleteData: false,
                accountNoSuffix: glDetail.accountNoSuffix,
                mixGlAccountNo: glDetail.glAcctNoMix,
                currRate: glDetail.currRate,
                itemNo: glDetail.itemNo,
                accountNo: glDetail.accountNo,
                transactionType: glDetail.transactionType
              }
              if (glDetail.glInterface === '6002' || glDetail.glInterface === '6003') {
                this.glAppIntInt = glDetail.glInterface
              }
              this.itemsGL.push(glDetailList)
            })
            this.loading = false
            this.calculateRemainAmount()
          }

          var errMsg
          var messages = []

          if (data.data.bankAcctStatus !== '') {
            messages.push({ message: data.data.bankAcctStatus, type: 'ERROR' })
          }
          if (data.data.bankChrgStatus !== '') {
            messages.push({ message: data.data.bankChrgStatus, type: 'ERROR' })
          }
          if (data.data.debtCtrlStatus !== '') {
            messages.push({ message: data.data.debtCtrlStatus, type: 'ERROR' })
          }

          errMsg = { messages }

          this.message(errMsg)
          this.fieldMessage(errMsg)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    calculateRemainAmount() {
      this.glListingForm.remainAmountToPost = '0.00'
      this.glListingForm.gstRemainAmount = '0.00'
      this.glListingForm.totalLocalAmount = '0.00'
      let tranCurr = this.nonTradeData.currency
      let tranCurrRate = this.nonTradeData.currencyRate

      for (var i = 0; i < this.itemsGL.length; i++) {
        if (tranCurr === this.itemsGL[i].curr) {
          this.glListingForm.remainAmountToPost = formatPrice(
            Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) - Number(removeFormatNumber(this.itemsGL[i].amount))
          )
        } else {
          this.glListingForm.remainAmountToPost = formatPrice(
            Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) -
              (Number(removeFormatNumber(this.itemsGL[i].amount)) * Number(this.itemsGL[i].currRate)) / Number(tranCurrRate)
          )
        }
        this.glListingForm.totalLocalAmount = formatPrice(
          Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) + Number(removeFormatNumber(this.itemsGL[i].localAmount))
        )
        this.glListingForm.gstRemainAmount = formatPrice(
          Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) + Number(removeFormatNumber(this.itemsGL[i].gstAmount))
        )
        if (this.itemsGL[i].glInterface === '6002') {
          if (this.nonTradeData.type === 'Z') {
            this.glListingForm.gstRemainAmount = formatPrice(
              Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) - Number(removeFormatNumber(this.itemsGL[i].amount))
            )
          } else {
            this.glListingForm.gstRemainAmount = formatPrice(
              Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) + Number(removeFormatNumber(this.itemsGL[i].amount))
            )
          }
        } else if (this.itemsGL[i].glInterface === '6003') {
          if (this.nonTradeData.type === 'Y') {
            this.glListingForm.gstRemainAmount = formatPrice(
              Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) - Number(removeFormatNumber(this.itemsGL[i].amount))
            )
          } else {
            this.glListingForm.gstRemainAmount = formatPrice(
              Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) + Number(removeFormatNumber(this.itemsGL[i].amount))
            )
          }
        } else if (this.itemsGL[i].gstStatus === 'B' && this.miscacctparams.paytBlkGstinExp) {
          // OS-805 - fys20210910
          if (this.itemsGL[i].accountNo === '' && this.itemsGL[i].type === 'Z') {
            this.glListingForm.gstRemainAmount = formatPrice(
              Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) - Number(removeFormatNumber(this.itemsGL[i].gstAmount))
            )
          }
        }
      }

      if ((Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) === 0.01 ||
        Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) === -0.01) &&
        Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) === 0 &&
        Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) === 0) {
        this.glListingForm.totalLocalAmount = '0.00'
      } else if (
        Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) === 0 &&
        (Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) === 0.01 ||
        Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) === -0.01) &&
        Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) === 0
      ) {
        this.glListingForm.remainAmountToPost = '0.00'
      } else if (
        Number(removeFormatNumber(this.glListingForm.totalLocalAmount)) === 0 &&
        Number(removeFormatNumber(this.glListingForm.remainAmountToPost)) === 0 &&
        (Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) === 0.01 ||
        Number(removeFormatNumber(this.glListingForm.gstRemainAmount)) === -0.01)
      ) {
        this.glListingForm.gstRemainAmount = '0.00'
      }

      this.loading = false
    },
    async doSaveGLTrans(actionName) {
      const apiURI = this.$store.state.nonTrade.menu.saveGLTrans
      if (apiURI) {
        try {
          const expand = {
            branch: this.nonTradeData.branch,
            accountNo: this.nonTradeData.accountNo,
            transactionType: this.nonTradeData.type,
            documentNo: this.nonTradeData.documentNo,
            fund: this.nonTradeData.fund,
            accountNoSuffix: this.nonTradeData.suffix,
            actionName: actionName,
            glDetailList: []
          }
          expand.glDetailList = this.itemsGL
          const result = await this.$http.post(apiURI, expand)

          const { data } = result
          if (data) {
            this.processingFlag = false
            this.notify(data)
            if (
              this.nonTradeData.printDoc === 'I' &&
              (this.nonTradeData.actionName === 'CREATE_SAVE_POST' || this.nonTradeData.actionName === 'UPDATE_SAVE_POST')
            ) {
              const commit = {
                branch: this.nonTradeData.branch,
                accountNo: this.nonTradeData.accountNo,
                type: this.nonTradeData.type,
                documentNo: this.nonTradeData.documentNo,
                fund: this.nonTradeData.fund,
                suffix: this.nonTradeData.suffix,
                actionName: this.nonTradeData.actionName,
                printDoc: this.nonTradeData.printDoc
              }
              if (this.nonTradeData.type === 'Z') {
                this.doExportAcctPaytDoc(commit)
              } else {
                this.doExportAcctDoc(commit)
              }
            }
            this.$router.push({ name: 'nonTrade' })
          }
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchGstStatus() {
      this.gstStatuses = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchGstStatus
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.gstStatuses.push(data)
              })
            }
          }
        })
      }
    },
    async fetchCurrency() {
      this.currencies = []
      let apiUrl = this.$store.state.nonTrade.menu.fetchCurrency
      if (apiUrl) {
        await this.$http.get(apiUrl).then(result => {
          if (result.data) {
            const { dataList } = result.data
            if (dataList) {
              dataList.map(data => {
                this.currencies.push(data)
              })
            }
          }
        })
      }
    }
  },
  mixins: [MessageMixin]
}
